// KWANKGM03030_事前審査申込入力（受付完了）
import React from 'react';
import TopArea from '../../molecules/TopArea';
import { StepNavigation as StepType } from '../../types/Template';
import Finish from './Finish';

interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  opened_mypage: boolean;
  ja_name: string;
  is_staff: boolean;
  display_status: boolean;
}

const PreExaminationFinish: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  opened_mypage,
  ja_name,
  is_staff,
  display_status,
}) => {
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <Finish
        ja_name={ja_name}
        reception_cd={reception_cd}
        is_staff={is_staff}
        opened_mypage={opened_mypage}
      />
    </>
  );
};

export default PreExaminationFinish;
